import { IconArrowRightFromLineOutline18 as BetweenHorizonalStart } from "nucleo-ui-outline-18"

import { ShortcutSymbols } from "@productlane/lib/src/shortcut-symbols"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const dividerCommand: SlashCommandDefinition = {
	key: "divider",
	title: "Divider",
	icon: <BetweenHorizonalStart strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).run()
		editor.commands.setHorizontalRule()
	},
	group: "blocks",
	shortcutIcons: [
		ShortcutSymbols.ALT,
		ShortcutSymbols.SHIFT,
		ShortcutSymbols["/"],
	],
}
